import { render, staticRenderFns } from "./knowledgeBaseArticle.vue?vue&type=template&id=592d13f2&"
import script from "./knowledgeBaseArticle.vue?vue&type=script&lang=js&"
export * from "./knowledgeBaseArticle.vue?vue&type=script&lang=js&"
import style0 from "./knowledgeBaseArticle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports